var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplicantWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4473 11.8223C15.9043 12.6348 15.3203 13.625 14.3809 13.625H2.21875C1.2793 13.625 0.695312 12.6094 1.15234 11.8223L7.24609 1.23438C7.70312 0.421875 8.89648 0.447266 9.35352 1.23438L15.4473 11.8223ZM8.3125 9.61328C7.65234 9.61328 7.14453 10.1465 7.14453 10.7812C7.14453 11.4414 7.65234 11.9492 8.3125 11.9492C8.94727 11.9492 9.48047 11.4414 9.48047 10.7812C9.48047 10.1465 8.94727 9.61328 8.3125 9.61328ZM7.19531 5.42383L7.37305 8.87695C7.39844 9.05469 7.52539 9.15625 7.67773 9.15625H8.92188C9.07422 9.15625 9.20117 9.05469 9.22656 8.87695L9.4043 5.42383C9.42969 5.24609 9.27734 5.09375 9.09961 5.09375H7.5C7.32227 5.09375 7.16992 5.24609 7.19531 5.42383Z",
    fill: "#F9A825"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicantWarningIcon);
export default __webpack_public_path__ + "static/media/applicant-warning-icon.2e1099c1.svg";
export { ForwardRef as ReactComponent };